import moment from 'moment';
import ParameterConstants from '../constants/ParameterConstants';


export async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}

export const convertToCurrency = (amount, currencyType = ParameterConstants.TURKISH_CULTURE) => {
    if (currencyType === ParameterConstants.TURKISH_CULTURE) {
        if (amount !== null && !isNaN(amount) && !isNaN(parseFloat(amount))) {
            amount = amount.toString().replace(",", ".")
            if (parseFloat(amount) < 0) {
                amount = amount.toString().replace("-", "")
                return "- " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(1,) + " " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(0, 1)
            }
            return new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(1,) + " " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(0, 1)
        } else {
            return "";
        }
    }
    //diğer para birimleri buraya eklenebilir.

}

export const convertToCurrencyByKey = (event, currencyType = ParameterConstants.TURKISH_CULTURE) => {
    let amount = getObjectDataWithPath(event.data, event.colDef.field);
    if (currencyType === ParameterConstants.TURKISH_CULTURE) {
        if (amount !== null && !isNaN(amount) && !isNaN(parseFloat(amount))) {
            amount = amount.toString().replace(",", ".")
            if (parseFloat(amount) < 0) {
                amount = amount.toString().replace("-", "")
                return "- " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(1,) + " " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(0, 1)
            }
            return new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(1,) + " " + new Intl.NumberFormat('tr', {style: 'currency', currency: 'TRY'}).format(amount).slice(0, 1)
        } else {
            return "";
        }
    }
    //diğer para birimleri buraya eklenebilir.*/
}

export const abstractRegistry = (registry, isSubscriber) => {
    let concreteRegistry = {};

    concreteRegistry.RetailRegistry = null;
    concreteRegistry.CorporateRegistry = null;
    concreteRegistry.PublicRegistry = null;
    concreteRegistry.ForeignRetailRegistry = null;
    concreteRegistry.OtherRegistry = null;
    concreteRegistry.UndetailedRegistry = null;
    if (registry) {
        let RegistryInfo = registry.RegistryInfo;
        let RegistryType = isSubscriber ? registry.SubscriberType : registry.RegistryType;
        if (RegistryType === ParameterConstants.RETAIL_SUBSCIBER) {
            concreteRegistry.RetailRegistry = RegistryInfo;
        }
        if (RegistryType === ParameterConstants.CORPORATE_SUBSCIBER) {
            concreteRegistry.CorporateRegistry = RegistryInfo;
        }
        if (RegistryType === ParameterConstants.PUBLIC_SUBSCIBER) {
            concreteRegistry.PublicRegistry = RegistryInfo;
        }
        if (RegistryType === ParameterConstants.FOREIGNER_RETAIL_SUBSCIBER) {
            concreteRegistry.ForeignRetailRegistry = RegistryInfo;
        }
        if (RegistryType === ParameterConstants.OTHER_SUBSCIBER) {
            concreteRegistry.OtherRegistry = RegistryInfo;
        }
        if (RegistryType === ParameterConstants.UNDETAILED_SUBSCRIBER) {
            concreteRegistry.UndetailedRegistry = RegistryInfo;
        }
    }
    return concreteRegistry
}


export const getObjectDataWithPath = (obj, path) => {
    //control all undefined and types
    if (obj === undefined || obj === null || typeof obj !== "object" || path === undefined || path === null || typeof path !== "string") {
        return undefined;
    }
    //split path
    let pathArray = path.split(".");
    //control pathArray
    if (pathArray.length === 0) {
        return undefined;
    }
    //get data
    let data = obj;
    for (let i = 0; i < pathArray.length; i++) {
        if (data[pathArray[i]] === undefined) {
            return undefined;
        }
        data = data[pathArray[i]];
    }
    return data;
}

export const convertToString = (value) => {
    try {
        if (value) {
            return (value).toString()
        } else return ""
    } catch (e) {
        return "";
    }
}


export const checkGsmNumber = (gsmNumber) => {
    if (gsmNumber !== null && gsmNumber !== undefined && gsmNumber !== "") {
        gsmNumber = gsmNumber.toString()
        gsmNumber = gsmNumber.replace("(", "").replace(")", "").replaceAll("_", "").replaceAll(" ", "")
        if (gsmNumber.length < 10) {
            throw new RangeError("Gsm Numarasını eksik girdiniz.")
        }
        if (gsmNumber.startsWith("5555555555")) {
            throw new RangeError("Gsm Numarası sadece 5'lerden oluşamaz.")
        }
        if (gsmNumber.startsWith("500")) {
            throw new RangeError("Gsm Numarası 500 ile başlayamaz.")
        }
        if (!gsmNumber.startsWith("5")) {
            throw new RangeError("Gsm Numarası 5 ile başlamalı.")
        }

        return gsmNumber
    } else {
        throw new RangeError("Gsm Numarası boş olamaz.")
    }
}

//Aggrid filtreleme tanımları
export const defaultColDef = {
    editable: false,
    sortable: true,
    flex: 1,
    filter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    floatingFilter: true,
    resizable: true,
}

export const defaultColDefWithScroll = {

    editable: false,
    sortable: true,
    filter: 'agMultiColumnFilter',
    floatingFilterComponentParams: { suppressFilterButton: true },
    floatingFilter: true,
    resizable: true,
}

export const defaultColDefWithScrollNoFilterText = {

    editable: false,
    sortable: true,
    filter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    floatingFilter: true,
    resizable: true,
}


export const defaultColDefWithoutFilter = {
    editable: false,
    sortable: true,
    flex: 1,
    filter: true,
    resizable: true,
}

export const isNullOrEmpty = (value) => {
    try {
        if (typeof (value) === "string") {
            if (value === "" || value === null || value === undefined) return true;
            else return false;
        } else if (typeof (value) === "object") {
            if (Object.keys(value).length === 0 || value === null) return true;
            else return false;
        } else if (typeof (value) === "array") {
            if (value.length === 0 || value === null) return true;
            else return false;
        } else {
            if (value === null || value === undefined) return true;
            else return false;
        }
    } catch (e) {
        return true
    }

}

export const convertTurkishCulture = (value, fixedNumber) => {
    return parseFloat((value ?? 0).toString()).toLocaleString('tr-TR', { minimumFractionDigits: fixedNumber, maximumFractionDigits: fixedNumber });
}

export const convertToBoolean = (value) => {
    if (value === true || value === "1" || value === 1) {
        return true
    } else return false
}

export const convertToDateTime = (value) => {
    if (value && value !== "") {
        if (moment(value).isValid()) {
            return moment(value, "DD.MM.YYYY").format()
        } else if (moment(value, "DD.MM.YYYY").isValid()) {
            return moment(value, "DD.MM.YYYY").format()
        } else DateTime.MinValue()
    }
    else return null

}

export const convertToDateFormat = (value, includeHour = false, includeSecond = false) => {
    if (value === "0001-01-01T00:00:00") return "";
    const dateFormat = `DD.MM.YYYY ${includeHour ? `${includeSecond ? "HH:mm:ss" : "HH:mm"}` : ""}`;
    if (moment(value).isValid()) {
        return moment(value).format(dateFormat);
    } else {
        DateTime.MinValue().format(dateFormat);
    }
}

export const getCurrentUserInfo = () => {
    return sessionStorage.getItem("userInfo") ? JSON.parse(sessionStorage.getItem("userInfo")) : null;
}


export const isIdentityNumberValid = (personPidNo) => {
    personPidNo = personPidNo.toString();
    if (personPidNo.length !== 11) return false;
    if (personPidNo[0] === '0') return false;
    let tekToplam = 0, ciftToplam = 0, genelToplam = 0;
    for (let i = 0; i < personPidNo.length - 2; i++) {
        if (i % 2 === 0) {
            tekToplam += parseInt(personPidNo[i]);
        } else {
            ciftToplam += parseInt(personPidNo[i]);
        }
        genelToplam += parseInt(personPidNo[i])
    }
    if (((tekToplam * 7) - ciftToplam) % 10 !== parseInt(personPidNo[personPidNo.length - 2])) return false;
    genelToplam += parseInt(personPidNo[9]);

    if (genelToplam % 10 !== parseInt(personPidNo[10])) return false;
    return true;
}


export const DateTime = {

    MinValue: () => { return moment("0001-01-01T00:00:00Z") },
    IsValid: (date) => { return moment(date, "DD.MM.YYYY", true).isValid() },
    AddDays: (date, addedDay) => { return moment(date).add(parseInt(addedDay), 'days').format() },
    DiffDays: (lastDate, firstDate) => { return moment(lastDate).diff(moment(firstDate), 'days') },
    AddYears: (date, addedYear) => { return moment(date).add(parseInt(addedYear), 'year').format() },
    Now: {
        Year: moment().year(),
        Month: moment().month() + 1,
        Day: moment().date(),
        Hour: moment().hour(),
        Minute: moment().minute(),
        Second: moment().second(),
        Millisecond: moment().millisecond(),
        Date: moment().format("DD.MM.YYYY"),
        Time: moment().format("HH:mm:ss")
    }
}


export const Session = (key, value = undefined) => {
    try {
        if (value === undefined) {
            value === null ? sessionStorage.setItem(key, null) : sessionStorage.setItem(key, JSON.stringify(value))
        } else {
            sessionStorage.getItem(key)
            return JSON.parse(sessionStorage.getItem(key))
        }
    } catch (e) {
        return;
    }
}



export const ConvertToRegistryTypeName = (data) => {
    if (data.RegistryType === 'G') {
        return "Gerçek";
    } else if (data.RegistryType === 'T') {
        return "Tüzel";
    } else if (data.RegistryType === 'K') {
        return "Kamu";
    } else if (data.RegistryType === 'D') {
        return "Diğer";
    } else if (data.RegistryType === 'Y') {
        return "Yabancı";
    } else if (data.RegistryType === 'U') {
        return "";
    }
    return "Bilinmiyor";
};

export const ConvertRegistryTaxOrIdentityNumber = (registry) => {
    if (registry !== null && registry.RegistryInfo != null) {
        var registryType = registry.RegistryType;
        if (registryType === ParameterConstants.RETAIL_SUBSCIBER || registryType === ParameterConstants.FOREIGNER_RETAIL_SUBSCIBER) {
            return registry.RegistryInfo.IdentityNumber;
        } else if (registryType === ParameterConstants.CORPORATE_SUBSCIBER || registryType === ParameterConstants.PUBLIC_FACILITY_TYPE_PARAMETER_TYPE || registryType === ParameterConstants.OTHER_SUBSCIBER) {
            return registry.RegistryInfo.TaxNumber;
        } else {
            return "Bilinmiyor"
        }
    } else {
        return "Bilinmiyor"
    }
};

export const ConvertRegistryNameOrTitle = (registry) => {
    if (registry) {
        if (registry !== null && registry.RegistryInfo !== null) {
            var registryType = registry.RegistryType;
            if (registryType === ParameterConstants.RETAIL_SUBSCIBER) {
                return `${registry.RegistryInfo.Name} ${registry.RegistryInfo.SurName}`;
            }
            else if (registryType === ParameterConstants.FOREIGNER_RETAIL_SUBSCIBER) {
                return `${registry.RegistryInfo.Name} ${registry.RegistryInfo.Surname}`;
            }
            else if (registryType === ParameterConstants.CORPORATE_SUBSCIBER || registryType === ParameterConstants.PUBLIC_FACILITY_TYPE_PARAMETER_TYPE || registryType === ParameterConstants.OTHER_SUBSCIBER) {
                return registry.RegistryInfo.Title;
            }
            else {
                return "Bilinmiyor"
            }
        } else {
            return "Bilinmiyor"
        }
    }
    else {
        return "Bilinmiyor"
    }
};

export const ConvertRegistryFatherNameOrRelatedPerson = (registry) => {
    if (registry !== null && registry.RegistryInfo != null) {
        var registryType = registry.RegistryType;
        if (registryType === ParameterConstants.RETAIL_SUBSCIBER || registryType === ParameterConstants.FOREIGNER_RETAIL_SUBSCIBER) {
            return registry.RegistryInfo.FatherName;
        } else if (registryType === ParameterConstants.CORPORATE_SUBSCIBER || registryType === ParameterConstants.PUBLIC_FACILITY_TYPE_PARAMETER_TYPE || registryType === ParameterConstants.OTHER_SUBSCIBER) {
            return registry.RegistryInfo.RelatedPerson;
        } else {
            return "Bilinmiyor"
        }
    } else {
        return "Bilinmiyor"
    }
};

export const ConvertRegistryMotherName = (registry) => {
    if (registry !== null && registry.RegistryInfo != null) {
        var registryType = registry.RegistryType;
        if (registryType === ParameterConstants.RETAIL_SUBSCIBER || registryType === ParameterConstants.FOREIGNER_RETAIL_SUBSCIBER) {
            return registry.RegistryInfo.MotherName;
        } else {
            return "Bilinmiyor"
        }
    } else {
        return "Bilinmiyor"
    }
};

export const ConvertRegistryType = (registry) => {
    const registryType = registry.RegistryType;
    let RegistryTypeName = ""
    switch (registryType) {
        case "G":
            RegistryTypeName = "GERÇEK"
            break;
        case "Y":
            RegistryTypeName = "YABANCI"
            break;
        case "T":
            RegistryTypeName = "TÜZEL"
            break;
        case "K":
            RegistryTypeName = "KAMU"
            break;
        case "D":
            RegistryTypeName = "DİĞER"
            break;
        case "U":
            RegistryTypeName = "TANIMSIZ"
            break;
        default:
            break;
    }
    return RegistryTypeName;
}
